<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col">
                    <div class="mb-3">
                        <label for="email">メールアドレス</label>
                        <input
                            v-model="admin.email"
                            type="text"
                            id="email"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.email }"
                            placeholder="メールアドレス"
                            readonly>
                        <div
                            v-if="errors.email"
                            class="invalid-feedback d-block">
                            {{ errors.email[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group mt-4">
            <h5 class="userAuthHeader">パスワード変更</h5>
            <div class="row">
                <div class="col">
                    <div class="mb-3 mb-0-sm">
                        <label for="current_password">現在のパスワード</label>
                        <input
                            v-model="current_password"
                            type="password"
                            id="current_password"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.current_password }"
                            placeholder="パスワードを入力">
                        <div
                            v-if="errors.current_password"
                            class="invalid-feedback d-block">
                            {{ errors.current_password[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mb-3 mb-0-sm">
                        <label for="new_password">新規パスワード</label>
                        <input
                            v-model="password"
                            type="password"
                            id="password"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.password }"
                            placeholder="新規パスワードを入力">
                        <div
                            v-if="errors.password"
                            class="invalid-feedback d-block">
                            {{ errors.password[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mb-3 mb-0-sm">
                        <label for="password_confirmation">新規パスワード（確認）</label>
                        <input
                            v-model="password_confirmation"
                            type="password"
                            id="password_confirmation"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.password }"
                            placeholder="新規パスワードを再入力">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <hr>
                    <ul class="mb-0">
                        <li class="mb-2">
                            <span>パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください</span>
                        </li>
                        <li class="mb-2">
                            <span>パスワードとして使用可能な記号は</span>
                            <span>&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span>
                            <span>です</span>
                        </li>
                    </ul>
                    <hr>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button
                class="btn btn-yokumiru-orange"
                :disabled="inProgress"
                @click="updatePassword">
                パスワードを更新
            </button>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            admin: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                errors: {},
                inProgress: false,
                current_password: '',
                password: '',
                password_confirmation: '',
            };
        },

        methods: {
            /**
             * パスワード更新
             */
            updatePassword: async function() {
                if (this.inProgress) return
                this.inProgress = true

                const data = {
                    email: this.admin.email,
                    current_password: this.current_password,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                }

                await axios.put(constants.admin.password.endpoint.base, data)
                    .then(() => {
                        this.current_password = ''
                        this.password = ''
                        this.password_confirmation = ''
                        this.errors = {}
                        bus.$emit('alert-success', 'パスワードを更新しました。')
                    })
                    .catch(({response}) => {
                        if (response &&
                            response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style scoped lang="scss">
.userAuthHeader {
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: bold;
    color: #7D868D;
}
</style>
